import { render, staticRenderFns } from "./dialog2.vue?vue&type=template&id=def96db4&scoped=true&"
import script from "./dialog2.vue?vue&type=script&lang=js&"
export * from "./dialog2.vue?vue&type=script&lang=js&"
import style0 from "./dialog2.vue?vue&type=style&index=0&id=def96db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def96db4",
  null
  
)

export default component.exports